import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import styles from './PricingPage.module.scss'

import PricingFlowBlock from 'components/modules/pricing/PricingFlowBlock'
import PricingContent from 'components/modules/pricing/PricingContent'
import { PricingActionsTypes } from 'store/pricing/actions'

const PricingPage: React.FC = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: PricingActionsTypes.PRICING_GET_PLANS })
  }, [dispatch])

  return (
    <div className={styles.wrapper}>
      <PricingFlowBlock />

      <PricingContent />
    </div>
  )
}

export default PricingPage
